let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("d8OKj")]).then(() => parcelRequire('l0bjd'));